// extracted by mini-css-extract-plugin
export var active = "_36-9";
export var backButton = "_36-8";
export var clone = "_36-e";
export var collapseBar = "_36-k";
export var collapseMode = "_36-m";
export var collapsed = "_36-o";
export var dimmed = "_36-i";
export var dragHandle = "_36-c";
export var dropdownIcon = "_36-g";
export var expanding = "_36-n";
export var hidden = "_36-x";
export var iconContainer = "_36-q";
export var iconSwapper = "_36-w";
export var navItem = "_36-6";
export var navItemIcon = "_36-f";
export var navProfile = "_36-7";
export var notificationCountBadge = "_36-j";
export var notificationDot = "_36-r";
export var optionsContainer = "_36-h";
export var primaryNav = "_36-0";
export var primaryNavDivider = "_36-v";
export var primaryNavResizeHandle = "_36-2";
export var primaryNavResizing = "_36-1";
export var primaryNavTabSection = "_36-u";
export var primaryTab = "_36-p";
export var primaryTabIconBox = "_36-s";
export var secondaryNav = "_36-3";
export var selected = "_36-t";
export var settingsNav = "_36-4";
export var settingsNavItems = "_36-5";
export var show = "_36-d";
export var sideNav = "_36-l";
export var teamItem = "_36-a";
export var userProfileItem = "_36-b";